module.exports = __webpack_public_path__ + "static/media/fr-FR.64d31b51.md";